import { apiClient } from './api';
import type {
  TickerQuote,
  CompanyProfile,
  FinancialsData,
  EarningsRow,
  InstitutionalHolder,
  DividendsData,
} from '../types/tickerDetail';

interface ApiResponse<T> {
  data: T;
  success: boolean;
}

const base = (symbol: string) => `/api/market-data/ticker/${symbol}`;

export const tickerDetailService = {
  getQuote: (symbol: string) =>
    apiClient.get<ApiResponse<TickerQuote>>(`${base(symbol)}/quote/`),

  getCompany: (symbol: string) =>
    apiClient.get<ApiResponse<CompanyProfile>>(`${base(symbol)}/company/`),

  getFinancials: (symbol: string, period: 'annual' | 'quarter' = 'annual') =>
    apiClient.get<ApiResponse<FinancialsData>>(
      `${base(symbol)}/financials/?period=${period}`
    ),

  getEarnings: (symbol: string) =>
    apiClient.get<ApiResponse<EarningsRow[]>>(`${base(symbol)}/earnings/`),

  getInstitutionalHolders: (symbol: string) =>
    apiClient.get<ApiResponse<InstitutionalHolder[]>>(
      `${base(symbol)}/institutional-holders/`
    ),

  getDividends: (symbol: string) =>
    apiClient.get<ApiResponse<DividendsData>>(`${base(symbol)}/dividends/`),
};
